/* MARTI & ROK — theme.js
   Behaviour only. Every interaction here is one Shopify can express: a variant
   change, a line-item quantity, an add-to-cart, a cookie consent. Nothing
   invents a cart interaction the platform does not have (§3).
   No dependencies. Ships into the theme as assets/theme.js. */

(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* --- Quantity -----------------------------------------------------------
     One control, clamped at 1. The output is aria-live so the change is
     announced rather than only seen. */
  $$("[data-qty]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var out = $("[data-qty-out]", btn.parentNode);
      if (!out) return;
      var next = Math.max(1, (parseInt(out.textContent, 10) || 1) + parseInt(btn.dataset.qty, 10));
      out.textContent = next;
      /* The theme posts a real form to /cart/add, and an <output> is not
         submitted. Where a hidden quantity field exists the control writes
         through to it, so the number the buyer sees is the number that is
         ordered. Nothing in the prototype carries the attribute, so this is
         inert here and the two copies of the file stay identical. */
      var host = btn.closest("form") || btn.closest("section") || document;
      var field = $("[data-qty-input]", host);
      if (field) field.value = next;
    });
  });

  /* --- Product gallery ---------------------------------------------------
     The thumbnails were markup only until 2026-08-26: <button>s that nothing
     bound, each announcing "View image N of M" while clicking did nothing at
     all. So a shop that sells pictures showed one picture, and
     storefront/tests/test_gallery.py passed the whole time -- it guarded the
     ORDER of images nobody could click.

     The stage image is swapped rather than the gallery re-rendered, so the
     stage keeps its height and the page does not move, which is the same rule
     the size control follows. A thumb with no data-full is a placeholder plate
     and is left inert rather than clearing the stage. */
  /* THE PICTURE IS FETCHED AND DECODED BEFORE ANYTHING ON THE SCREEN MOVES
     (the principal, 2026-09-19: "images on live load pretty slow so its weird
     ... the image resizes and waits for seconds then the image changes").

     Two defects were stacked under that sentence and only the second is about
     speed.

     THE GEOMETRY USED TO CHANGE FIRST. `--ar` was assigned in the same tick as
     `src`, and the stage's width follows its aspect ratio, so the box took the
     NEW photograph's proportion instantly and then held the OLD photograph,
     cover-cropped into a shape that is not its own, until the download
     finished. Nothing was loading slowly enough to explain that on its own --
     the wait only looked broken because the page had already rearranged itself
     around a picture that was not there yet. So the swap now happens in one
     frame, after the bytes are in: proportion, picture and alt text together,
     or none of them.

     AND EVERY SWAP ASKED FOR THE BIGGEST RENDER THERE IS. Measured on the live
     shop the day this was written: `data-full` is the 1600px file, and the room
     shot at 1600 is 395 KB against 167 KB at 900 and 80 KB at 600. The first
     picture on the page is responsive -- `img-srcset` gives it the whole ladder
     -- and this code then threw that away, so every picture after the first was
     the full 1600 on a phone painting it into about 360 CSS pixels. The
     preloader now carries the same `srcset` and `sizes` the page would have
     used and lets the BROWSER choose the width.

     `currentSrc` is what makes that safe. It is the file the browser actually
     picked, so the stage is handed that exact URL with no srcset on it -- the
     rule below is still literally true, there is no second selection that could
     resolve differently, and the file is already in cache, so the swap paints
     in the frame it is assigned.

     THE OLD RULE STANDS AND IS THE REASON `currentSrc` IS USED RATHER THAN A
     SRCSET ON THE STAGE: a browser ignores `src` entirely while a `srcset` is
     present, so assigning `src` alone would leave the stage showing the lead
     photograph however many thumbs were clicked -- the dead control that was
     fixed on 2026-08-26, coming back as a side effect of making the first paint
     smaller. */
  function warm(btn) {
    if (btn._warm || !btn.dataset.full) return btn._warm;
    var im = new Image();
    /* The ladder and the `sizes` promise come off the button, written there by
       the same `img-srcset` snippet that writes the stage's own. The prototype
       serves one file per photograph and carries neither, so it falls through
       to the plain URL and behaves exactly as it did. */
    if (btn.dataset.srcset) {
      im.sizes = btn.dataset.sizes || "100vw";
      im.srcset = btn.dataset.srcset;
    }
    im.src = btn.dataset.full;
    btn._warm = im;
    return im;
  }

  $$("[data-thumb]").forEach(function (btn) {
    /* Start the download on the way to the click. On a mouse that is most of a
       second of head start and the swap is then instant; on a touch screen it
       is the gap between the finger landing and lifting, which is small but
       free. Nothing is fetched for a thumb nobody reaches for. */
    ["pointerenter", "focus", "touchstart"].forEach(function (ev) {
      btn.addEventListener(ev, function () { warm(btn); }, { passive: true });
    });

    btn.addEventListener("click", function () {
      var media = btn.closest(".product-media");
      var stage = media && $("[data-stage]", media);
      if (!stage || !btn.dataset.full) return;

      /* THE CONTROL ANSWERS AT ONCE EVEN THOUGH THE PICTURE CANNOT. Holding
         `aria-current` back until the bytes arrive would make the thumbnails
         feel dead for exactly as long as the download takes, which is the
         complaint this whole block is about wearing different clothes. */
      $$("[data-thumb]", media).forEach(function (b) {
        b.removeAttribute("aria-current");
      });
      btn.setAttribute("aria-current", "true");

      var token = (stage._swap = (stage._swap || 0) + 1);
      var im = warm(btn);

      /* Said only if the wait is long enough to be noticed. A cached picture
         swaps inside a frame, and a dimmed stage that un-dims in the same
         frame is a flicker announcing nothing. */
      var slow = setTimeout(function () {
        if (token === stage._swap) stage.setAttribute("data-swapping", "");
      }, 160);

      function put() {
        clearTimeout(slow);
        /* A later click has already won. Two swaps in flight must not land in
           the order their downloads happened to finish. */
        if (token !== stage._swap) return;
        stage.removeAttribute("srcset");
        stage.removeAttribute("sizes");
        stage.src = im.currentSrc || btn.dataset.full;
        stage.alt = btn.dataset.alt || "";
        if (btn.dataset.ar) stage.style.setProperty("--ar", btn.dataset.ar);
        stage.removeAttribute("data-swapping");
      }

      if (im.complete) { put(); return; }
      /* `error` lands on `put` as well, on purpose: a picture that will not
         load has to reach the stage and show the browser's own broken state.
         Returning early would leave the previous photograph under a thumbnail
         marked current, which is a page lying about what it is showing. */
      im.addEventListener("load", put);
      im.addEventListener("error", put);
    });
  });

  /* --- Lightbox -----------------------------------------------------------
     The print at the height of the screen, on paper. Opened from the stage,
     swiped or arrowed through, closed with Escape or the paper around it.

     IT IS BUILT FROM THE THUMBNAILS, NOT FROM THE PAGE'S SOURCE. Nothing was
     added to `sections.py` or to `product-main.liquid`: the gallery is already
     written twice in this repository, once in Python and once in Liquid, and a
     second list of the same photographs in both files is a second pair of
     copies to keep in step -- which is the drift this theme keeps finding. The
     thumbs already carry every fact the lightbox needs (`data-full`,
     `data-alt`, which edition a photograph belongs to, and which one the stage
     is showing), so they are the source and there is one of them.

     WHICH IS ALSO WHY THE EDITION CONTROL NEEDS NO CODE HERE. Switching
     edition hides one set of thumbs and shows the other; this reads the
     visible ones each time it opens, so it can never show the annotated footer
     to somebody who has Standard checked (P1.57).

     A real <dialog>, opened with showModal(). Escape, the focus trap, the top
     layer and the page behind going inert are the platform's, not ours -- a
     hand-rolled trap is a long, subtle thing to get right and this one is
     already written. A browser with no showModal() installs NOTHING: no
     dialog, no cue on the stage, and the product page behaves exactly as it
     did before. The lightbox is an enhancement on top of a page that already
     works, never a step in the buy path. */
  (function () {
    var media = $(".product-media");
    if (!media) return;
    var stage = $("[data-stage]", media);
    /* A piece with no photo set renders placeholder plates whose buttons carry
       neither `data-thumb` nor `data-full`. There is nothing to enlarge, so no
       cue is drawn -- an affordance that opens an empty screen is worse than
       no affordance. */
    if (!stage || !$("[data-thumb][data-full]", media)) return;
    var dlg = document.createElement("dialog");
    if (typeof dlg.showModal !== "function") return;

    /* Drawn, not written. theme.js ships into a theme whose copy goes through
       the locale files, and a word rendered from here would be English on
       every storefront. One stroke, `non-scaling-stroke` so a scaled viewBox
       cannot thicken it -- the rule the size diagram already follows. */
    function icon(box, d, w, h) {
      return '<svg viewBox="' + box + '" width="' + w + '" height="' + h + '" fill="none" ' +
             'stroke="currentColor" stroke-width="1" aria-hidden="true">' +
             '<path d="' + d + '" vector-effect="non-scaling-stroke"/></svg>';
    }
    var EXPAND = icon("0 0 18 18", "M1 6.5V1h5.5M11.5 1H17v5.5M17 11.5V17h-5.5M6.5 17H1v-5.5", 18, 18);
    var PREV   = icon("0 0 12 20", "M10.5 1 1.5 10l9 9", 12, 20);
    var NEXT   = icon("0 0 12 20", "M1.5 1l9 9-9 9", 12, 20);
    var CLOSE  = icon("0 0 16 16", "M1 1l14 14M15 1L1 15", 16, 16);

    /* The only English in this block, kept together so a translator has one
       place to look. Every one of them is an accessible name; none is painted
       on the screen. */
    var TEXT = { open: "View at full size", close: "Close",
                 prev: "Previous image", next: "Next image", images: "Images" };

    var opener = document.createElement("button");
    opener.type = "button";
    opener.className = "stage__open";
    opener.setAttribute("aria-label", TEXT.open);
    opener.innerHTML = '<span class="stage__cue">' + EXPAND + '</span>';
    stage.parentNode.appendChild(opener);

    dlg.className = "lb";
    dlg.setAttribute("aria-label", TEXT.images);
    dlg.innerHTML =
      '<div class="lb__track" data-lb-track tabindex="0" role="region" aria-label="' + TEXT.images + '"></div>' +
      '<div class="lb__bar">' +
        '<button type="button" class="lb__nav lb__nav--prev" aria-label="' + TEXT.prev + '">' + PREV + '</button>' +
        '<p class="lb__count small num" aria-live="polite"></p>' +
        '<button type="button" class="lb__nav lb__nav--next" aria-label="' + TEXT.next + '">' + NEXT + '</button>' +
      '</div>' +
      '<button type="button" class="lb__close" aria-label="' + TEXT.close + '">' + CLOSE + '</button>';
    document.body.appendChild(dlg);

    var track = $(".lb__track", dlg);
    var bar   = $(".lb__bar", dlg);
    var count = $(".lb__count", dlg);
    var prev  = $(".lb__nav--prev", dlg);
    var next  = $(".lb__nav--next", dlg);
    var shown = -1;
    var sig   = "";

    function calm() {
      try { return window.matchMedia("(prefers-reduced-motion: reduce)").matches; }
      catch (e) { return false; }
    }
    /* The thumbs this edition is showing, in the order the page shows them. */
    function shots() {
      return $$("[data-thumb][data-full]", media).filter(function (b) { return !b.hidden; });
    }

    /* Rebuilt only when the set of photographs changes -- so reopening is
       instant and switching edition is honest. Clearing on every close would
       fade all five in again from cache for no reason. */
    function fill(list, start) {
      var s = list.map(function (b) { return b.dataset.full; }).join("|");
      if (s === sig) return;
      sig = s;
      track.innerHTML = "";
      list.forEach(function (b, i) {
        var fig = document.createElement("figure");
        fig.className = "lb__slide";
        var img = document.createElement("img");
        img.className = "lb__img";
        img.alt = b.dataset.alt || "";
        img.decoding = "async";
        /* Everything but the one being opened is off-screen horizontally, so
           the browser holds it back until it is scrolled toward. */
        if (i !== start) img.loading = "lazy";
        img.src = b.dataset.full;
        if (img.complete) img.setAttribute("data-loaded", "");
        else img.addEventListener("load", function () { img.setAttribute("data-loaded", ""); });
        fig.appendChild(img);
        track.appendChild(fig);
      });
    }

    /* The index is read off the scroll position rather than tracked in a
       variable, so a swipe, a keypress and a chevron all answer to the same
       thing and none of them can leave the counter saying something the screen
       is not showing. */
    function at() {
      var n = track.children.length;
      if (!n) return 0;
      var i = Math.round(track.scrollLeft / (track.clientWidth || 1));
      return Math.max(0, Math.min(n - 1, i));
    }
    function paint() {
      var i = at();
      if (i === shown) return;
      shown = i;
      var n = track.children.length;
      count.textContent = (i + 1) + " / " + n;
      prev.disabled = i === 0;
      next.disabled = i === n - 1;
      /* A print with one photograph has nothing to page through, and a plaque
         reading `1 / 1` between two dead chevrons is chrome about nothing. */
      bar.hidden = n < 2;
      /* THE ONE EITHER SIDE IS FETCHED NOW, NOT WHEN IT IS SWIPED TO. `lazy`
         holds a slide back until it nears the viewport, and in a horizontal
         scroller that is far too late: the photograph starts downloading as
         the swipe lands, so the reader arrives on blank paper. Promoting the
         neighbours starts their load immediately, and nothing beyond them is
         touched -- a five-picture gallery must not become five full-size
         downloads because somebody opened it. */
      [i - 1, i + 1].forEach(function (j) {
        var slide = track.children[j];
        var img = slide && slide.firstChild;
        if (img && img.loading === "lazy") img.loading = "eager";
      });
    }
    function to(i, jump) {
      var w = track.clientWidth || 1;
      i = Math.max(0, Math.min(track.children.length - 1, i));
      track.scrollTo({ left: i * w, behavior: (jump || calm()) ? "auto" : "smooth" });
    }

    var ticking = false;
    track.addEventListener("scroll", function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; paint(); });
    }, { passive: true });

    prev.addEventListener("click", function () { to(at() - 1); });
    next.addEventListener("click", function () { to(at() + 1); });
    $(".lb__close", dlg).addEventListener("click", function () { dlg.close(); });

    dlg.addEventListener("keydown", function (e) {
      /* ESCAPE IS HANDLED HERE AS WELL AS BY THE PLATFORM, AND IT WAS MEASURED
         BEFORE IT WAS WRITTEN. A modal <dialog> is supposed to answer the
         browser's own close request: on this machine the keydown arrived, no
         `cancel` event followed, and the lightbox stayed open over the shop.
         The platform is still the mechanism -- this only calls the same
         `close()` -- and `close()` on a dialog that the browser has already
         shut does nothing, so the two cannot fight. */
      if (e.key === "Escape")         { e.preventDefault(); dlg.close(); }
      else if (e.key === "ArrowRight"){ e.preventDefault(); to(at() + 1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); to(at() - 1); }
      else if (e.key === "Home")      { e.preventDefault(); to(0); }
      else if (e.key === "End")       { e.preventDefault(); to(track.children.length - 1); }
    });

    /* Clicking the paper around the print closes it; clicking the print does
       not. The pointer distance is the guard: a swipe ends in a click event
       too, and without it every flick on a phone would shut the lightbox. */
    var from = null;
    track.addEventListener("pointerdown", function (e) { from = [e.clientX, e.clientY]; });
    track.addEventListener("click", function (e) {
      if (e.target.tagName === "IMG") return;
      if (from && (Math.abs(e.clientX - from[0]) > 8 || Math.abs(e.clientY - from[1]) > 8)) return;
      dlg.close();
    });

    /* A resize changes the width a slide is measured in, so the snap point
       moves out from under the picture. Put it back on the one being read. */
    window.addEventListener("resize", function () {
      if (dlg.open) to(shown, true);
    });

    opener.addEventListener("click", function () {
      var list = shots();
      if (!list.length) return;
      var start = 0;
      list.forEach(function (b, i) {
        if (b.getAttribute("aria-current") === "true") start = i;
      });
      fill(list, start);
      shown = -1;
      dlg.showModal();
      /* After showModal, never before: a closed dialog is display:none and
         measures zero, so a scroll written first lands at the first slide. */
      to(start, true);
      paint();
      /* iOS still scrolls the page behind a modal dialog. */
      document.documentElement.style.overflow = "hidden";
      track.focus();
    });

    dlg.addEventListener("close", function () {
      document.documentElement.style.overflow = "";
      opener.focus();
    });
  })();

  /* --- Size selection -----------------------------------------------------
     The authored moment. Changing size moves the fill in the diagram and the
     figure in the button. Neither moves the page: the stage keeps its height,
     and the price is tabular.

     The sizes nest strictly, so a sheet smaller than the selected one falls
     inside the filled area and switches to a paper stroke. That is a rule, not
     a lookup: index below selected is inside, index above is outside. */
  $$("fieldset.sizes").forEach(function (set) {
    var scope  = set.closest("section") || document;
    var sheets = $$(".sized .sheet[data-i]", scope);
    var priceOut = $("[data-price-out]", scope);
    var order = $$("input[type=radio]", set).map(function (i) { return i.value; });

    set.addEventListener("change", function (e) {
      var input = e.target;
      if (!input || input.type !== "radio") return;
      var sel = order.indexOf(input.value);

      sheets.forEach(function (r) {
        var i = parseInt(r.dataset.i, 10);
        r.classList.toggle("sheet--on", i === sel);
        r.classList.toggle("sheet--in", i < sel);
      });

      if (priceOut && input.dataset.price) priceOut.textContent = input.dataset.price;

      /* THE VARIANT ID IS NO LONGER WRITTEN FROM THIS RADIO. It used to be
         `idField.value = input.value`, which was right exactly while a print
         had one option. With Edition as option 2 the thing in the cart is
         decided by both controls and by neither alone, so it is resolved from
         the map by `resolveVariant` below -- and the size radio now carries
         the size OPTION VALUE rather than a variant id. wall.js is
         unaffected: it reads data-mm-w and data-mm-h, never the value. */

      var add = $("[data-add]", scope);
      if (add && add.dataset.state === "added") {
        delete add.dataset.state;
        add.firstChild.nodeValue = "Add to cart — €";
      }
      resolveVariant(scope);
    });
  });

  /* --- Edition ------------------------------------------------------------
     The second buyable variant of a print: the same artwork on a sheet with a
     printed footer (P1.57). Two things move when it changes, and they are
     separate on purpose.

     THE GALLERY. Both editions' photographs are in the markup and one set is
     hidden. Switching shows that edition's pictures and puts its first one on
     the stage. It is not a filter over one merged gallery: these are
     photographs of two different printed sheets, and showing the annotated
     footer while Standard is checked is showing type that will not be on the
     buyer's print.

     THE VARIANT. Size is option 1 and Edition is option 2, so the thing that
     goes in the cart is decided by BOTH controls and by neither alone. That
     is why the id is resolved from a map rather than carried on a radio: a
     radio can only know its own answer, and the previous version wrote the
     size radio's value straight into the hidden field — correct while a print
     had three variants and quietly wrong the moment it had six. */
  function editionOf(scope) {
    var checked = $("fieldset.editions input:checked", scope);
    return checked ? checked.value : "";
  }

  /* THIS IS NOT CALLED AT LOAD, AND THAT IS DELIBERATE (W-1, 2026-09-03).

     It runs from the two change handlers and nowhere else. When the page's
     opening variant was wrong -- every product page posted the annotated sheet
     while the Edition control read Standard -- a call here on DOMContentLoaded
     looked like the fix, and it is the wrong one twice over.

     A page has to be right with no JavaScript at all: the hidden id is what a
     form posts, and a shop that needs a script to put the correct thing in the
     basket is one script error away from selling the wrong sheet again. And a
     reconciliation at load would have SILENCED the defect rather than fixed
     it -- the markup would have gone on disagreeing with itself, corrected a
     frame later, with a visible flash of the wrong price and nothing left for
     a test to see. Liquid decides the opening variant; this only ever answers
     a click. Do not add a load-time call to "finish" it. */
  function resolveVariant(scope) {
    var host = $("[data-variant-map]", scope);
    var idField = $("[data-variant-input]", scope);
    if (!host || !idField) return;              /* prototype: no cart, no map */
    var map;
    try { map = JSON.parse(host.dataset.variantMap || "{}"); } catch (e) { return; }
    var size = $("fieldset.sizes input:checked", scope);
    if (!size) return;
    /* Nested by size, then edition -- never one joined key. A separator
       would have to be a character no option value can contain, and
       Liquid has no escape for the invisible ones, so the two copies of
       this file could only ever have agreed by luck. */
    var bySize = map[size.value] || {};
    var row = bySize[editionOf(scope)];
    /* NO FALLBACK TO A DIFFERENT VARIANT. A combination the shop does not
       carry must leave the form unable to post rather than post a variant the
       buyer did not choose -- which is how a shop sells the standard sheet to
       somebody who picked the annotated one and never finds out. */
    var add = $("[data-add-submit]", scope) || $("button[name=add]", scope);
    if (!row) {
      idField.value = "";
      if (add) { add.disabled = true; add.setAttribute("aria-disabled", "true"); }
      return;
    }
    idField.value = row.id;
    if (add) {
      add.disabled = !row.ok;
      if (row.ok) add.removeAttribute("aria-disabled");
      else add.setAttribute("aria-disabled", "true");
    }
    var priceOut = $("[data-price-out]", scope);
    if (priceOut && row.price) priceOut.textContent = row.price;

    /* THE SIZE LIST IS REPRICED FOR THE CHOSEN EDITION, not left as it was
       rendered. Both editions cost the same today -- same paper, same size,
       same print cost, one answer from posters.retail_for() -- so this
       changes nothing on the live shop. It is here because "the two are
       always equal" is a fact about a price table, not a property of the
       markup, and a control showing one edition's prices while the buyer has
       chosen the other is the kind of quietly-wrong page this theme keeps
       finding. Six lines is cheaper than a rule somebody has to remember. */
    $$("fieldset.sizes input[type=radio]", scope).forEach(function (r) {
      var alt = (map[r.value] || {})[editionOf(scope)];
      if (!alt || !alt.price) return;
      r.dataset.price = alt.price;
      var cell = $(".size__p", r.parentNode);
      if (cell) cell.textContent = alt.price;
    });
  }

  $$("fieldset.editions").forEach(function (set) {
    var scope = set.closest("section") || document;
    var media = $(".product-media", scope);

    set.addEventListener("change", function (e) {
      var input = e.target;
      if (!input || input.type !== "radio") return;

      if (media) {
        var first = null;
        $$("[data-thumb]", media).forEach(function (b) {
          var mine = b.dataset.edition === input.value;
          b.hidden = !mine;
          b.removeAttribute("aria-current");
          if (mine && !first) first = b;
        });
        /* Clicking the thumb rather than reassigning the stage here: the
           thumb handler already clears srcset before setting src, and a
           second copy of that rule is a second place for it to be forgotten.
           It was forgotten once already, and the stage stopped responding. */
        if (first) first.click();
      }
      resolveVariant(scope);
    });
  });

  /* --- Add to cart --------------------------------------------------------
     Immediate, in place. No modal, no drawer that hijacks (§6). The label
     states the outcome and the masthead count ticks; both revert so the
     control never lies about what it will do next. */
  $$("[data-add]").forEach(function (btn) {
    var revert;
    btn.addEventListener("click", function () {
      var scope = btn.closest("section") || document;
      var qty = parseInt(($("[data-qty-out]", scope) || {}).textContent, 10) || 1;

      $$("[data-cart-count]").forEach(function (c) {
        c.textContent = (parseInt(c.textContent, 10) || 0) + qty;
      });

      btn.dataset.state = "added";
      btn.firstChild.nodeValue = "Added — €";
      btn.setAttribute("aria-live", "polite");

      clearTimeout(revert);
      revert = setTimeout(function () {
        delete btn.dataset.state;
        btn.firstChild.nodeValue = "Add to cart — €";
      }, 2400);
    });
  });

  /* --- Remove line ---------------------------------------------------------
     The prototype has no server, so its Remove is a <button> and this deletes
     the row to show the interaction. The THEME's Remove is a real link to
     /cart/change?quantity=0 -- and it kept the same class for styling, so
     until 2026-08-26 this fired there too, with no preventDefault: the row
     vanished locally, then the page reloaded from the server. Harmless on
     success; on a failed request the buyer watched a line disappear that was
     still in their cart, beside a subtotal that never moved.

     Simulating is now conditioned on the control being a <button>, which is
     what tells the two apart. A link is left alone and the platform handles
     it. Same lesson as [data-add] and [data-newsletter] -- the difference is
     that those two were disarmed by removing the attribute, and this one
     could not be, because the class is load-bearing for the CSS. */
  $$(".ledger__x").forEach(function (btn) {
    if (btn.tagName !== "BUTTON") return;
    btn.addEventListener("click", function () {
      var row = btn.closest("tr");
      if (row) row.remove();
    });
  });

  /* --- Newsletter ---------------------------------------------------------
     Inline, next to the field, in words (§6). Names the problem and the
     recovery; never a modal, never on load (§8). */
  $$("[data-newsletter]").forEach(function (form) {
    var input = $("input", form);
    var msg = $("[data-nl-msg]", form);
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var v = (input.value || "").trim();
      var ok = /^[^@\s]+@[^@\s.]+\.[^@\s]{2,}$/.test(v);
      msg.hidden = false;
      msg.className = ok ? "field__ok" : "field__err";
      msg.textContent = ok
        ? "Subscribed. Four or five emails a year, and an unsubscribe link in every one."
        : (v ? "That address is missing everything after the @. Check it and try again."
             : "An email address is needed here.");
      form.toggleAttribute("data-error", !ok);
      input.setAttribute("aria-invalid", ok ? "false" : "true");
      input.setAttribute("aria-describedby", msg.id || (msg.id = "nl-msg"));
      if (ok) input.value = "";
    });
  });

  /* --- Colour scheme ------------------------------------------------------
     Light is the default and is never inferred from the operating system. */
  var scheme = (function () { try { return localStorage.getItem("mr-scheme") || "light"; } catch (e) { return "light"; } })();
  /* The country/currency control. `closest("form")` is what makes one file
     serve both surfaces: on the shop the select sits inside Shopify's
     `{% form 'localization' %}` and changing it submits; in the prototype
     there is no form around it, so this no-ops rather than navigating
     nowhere. The <noscript> button is the route without this handler. */
  $$("[data-market]").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var f = sel.closest("form");
      if (f) f.submit();
    });
  });

  function applyScheme(v) {
    if (v === "dark") document.documentElement.dataset.theme = "dark";
    else delete document.documentElement.dataset.theme;
    $$("[data-scheme]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(b.dataset.scheme === v));
    });
    try { localStorage.setItem("mr-scheme", v); } catch (e) {}
  }
  $$("[data-scheme]").forEach(function (b) {
    b.addEventListener("click", function () { applyScheme(b.dataset.scheme); });
  });
  applyScheme(scheme);

  /* --- Cookies ------------------------------------------------------------
     Decline-by-default, minimal, dismissible, never blocking the page (§8).
     Both actions carry identical weight.

     Until 2026-08-26 this wrote localStorage and hid the bar, and did nothing
     else. `Shopify.customerPrivacy.setTrackingConsent` was never called
     anywhere in the theme, so DECLINE CHANGED NOTHING -- Shopify's own scripts
     loaded either way -- while the copy told an EU visitor "Nothing measures
     you unless you say so." A consent notice that makes a claim it does not
     enforce is a worse position than no notice, and it is the same class as
     the [data-newsletter] and [data-add] simulations the port removed.

     The choice is now carried to Shopify. The local record is kept only to
     decide whether to show the bar again; it is not the consent itself. */
  function tellShopify(choice) {
    var S = window.Shopify;
    /* Absent in the prototype, which has no Shopify runtime, so this whole
       branch is inert there and the two copies of this file stay identical. */
    if (!S || typeof S.loadFeatures !== "function") return;
    S.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function (err) {
      if (err || !S.customerPrivacy) return;
      var yes = choice === "accept";
      S.customerPrivacy.setTrackingConsent({
        analytics: yes, marketing: yes, preferences: yes, sale_of_data: false
      }, function () {});
    });
  }

  var bar = $("[data-cookies]");
  var stored;
  try { stored = localStorage.getItem("mr-cookies"); } catch (e) {}
  /* Re-declare a stored choice on every load. Choices made before this was
     wired were recorded and never carried anywhere; this is what makes them
     take effect rather than quietly staying decorative. */
  if (stored) tellShopify(stored);
  if (bar) {
    if (!stored) bar.hidden = false;
    $$("[data-cookie]", bar).forEach(function (b) {
      b.addEventListener("click", function () {
        try { localStorage.setItem("mr-cookies", b.dataset.cookie); } catch (e) {}
        tellShopify(b.dataset.cookie);
        bar.hidden = true;
      });
    });
  }

  /* --- Images -------------------------------------------------------------
     Space is reserved by the plate's aspect-ratio, so an image fades in
     without moving anything below it. */
  $$(".plate img").forEach(function (img) {
    if (img.complete) img.setAttribute("data-loaded", "");
    else img.addEventListener("load", function () { img.setAttribute("data-loaded", ""); });
  });

  /* --- The catalogue cell's room shot -------------------------------------
     Hovering a cell shows the same print on a wall (the principal,
     2026-09-15). The room photograph ships with `data-src` and no `src`, so
     nothing is fetched until it is about to be seen: a phone can never reveal
     it, and a desktop reader who never hovers a given cell never pays for it
     either. On a catalogue of three dozen prints that is the difference
     between one image per cell and two.

     Fetched on the FIRST hover or keyboard focus and then left alone --
     `data-src` is removed, so a reader sweeping the mouse across the grid
     starts each fetch once. The fade is held until `load`, because the CSS
     only reveals `[data-loaded]`.

     Pointer devices only, and it is the same query the CSS is fenced with. A
     touch device that fired `pointerenter` on the way to a tap would fetch a
     photograph nothing can show. */
  var pointer = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)");
  if (!pointer || pointer.matches) {
    // DELEGATED, because the catalogue is not all in the first render. The
    // grid appends the next chunk as the reader scrolls, so cells bound at
    // load are only the ones that happened to arrive first -- the rest would
    // have had no hover at all, silently, on exactly the long catalogue this
    // is for. `pointerover` and `focusin` bubble; `pointerenter` and `focus`
    // do not, which is why they are not the events used here.
    var wake = function (e) {
      var cell = e.target && e.target.closest && e.target.closest(".item");
      if (!cell) return;
      var room = $(".item__room[data-src]", cell);
      if (!room) return;
      var src = room.getAttribute("data-src");
      room.removeAttribute("data-src");          // fetch once, not once per sweep
      room.addEventListener("load", function () { room.setAttribute("data-loaded", ""); });
      room.src = src;
    };
    document.addEventListener("pointerover", wake);
    document.addEventListener("focusin", wake);
  }
})();

/* Collection and colour filters, and the sort control.
   The select shipped with nothing bound to it. A control that does nothing is
   worse than no control: it reads as broken rather than absent. */
(function () {
  "use strict";
  /* This block sits outside the main closure above, so it cannot borrow its
     $ and $$ helpers -- doing so threw a ReferenceError and killed the whole
     filter behaviour silently. */
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) {
    return Array.prototype.slice.call((r || document).querySelectorAll(s));
  };

  var bar = $("[data-filters]");
  var state = { collection: null, colour: null };

  /* SCOPED TO THE CATALOGUE, not to the document.
     `$$(".item")` reached every cell on the page, so the moment a second
     section reused `.item` the filter hid it: picking any colour emptied the
     hand-picked sets shelf, sets included that were that very colour, because
     a set card carries no data-colour and "no colour" never matches one.
     The catalogue marks itself with [data-filter-scope]; anything outside it
     is somebody else's section and none of this control's business. Falling
     back to `document` keeps a page that has not marked a scope working
     exactly as before. */
  var scope = $("[data-filter-scope]") || document;

  /* data-colour is a SPACE-SEPARATED LIST -- every colour family the picture
     is made of (palette.families), so a pink-and-teal print answers both
     chips. An equality test here filed a rust-and-blue print under one of
     them only, and the one it chose was often neither (2026-09-22). */
  function apply() {
    var shown = 0;
    $$(".item", scope).forEach(function (el) {
      var ok = (!state.collection || el.dataset.collection === state.collection) &&
               (!state.colour ||
                (" " + (el.dataset.colour || "") + " ").indexOf(" " + state.colour + " ") !== -1);
      el.hidden = !ok;
      if (ok) shown++;
    });
    /* A collection heading with every print hidden beneath it is a lie about
       what is there -- AND IT WAS EXACTLY THAT, on the live shop, for as long
       as this ran. The catalogue's range heading is `<div
       class="plate-full__meta">` (catalogue-body.liquid, and catalogue_grid()
       in the prototype); none of `.small, h2, .grid-head` matches it, so the
       branch that hides it has never once executed. Read off the live page
       2026-09-15: filter to Yellow and the Forestry grid hides while the word
       Forestry stays on screen over nothing. A test binds this selector to the
       class the two builders actually emit.

       This is also the whole of "no category brackets": the sort below empties
       the range grids rather than hiding their headings itself, so heading
       visibility stays owned by one function. */
    $$(".grid", scope).forEach(function (g) {
      var any = $$(".item", g).some(function (i) { return !i.hidden; });
      var head = g.previousElementSibling;
      g.hidden = !any;
      if (head && head.matches(".plate-full__meta, .small, h2, .grid-head"))
        head.hidden = !any;
      /* AND THE BAND, NOT ONLY WHAT IS IN IT. A range section that keeps its
         `band-s` padding is a blank stripe where a range used to be -- four of
         them stacked above the flat grid when a sort empties every range.
         Only a section the scope owns: `apply()` may not reach out of the
         catalogue and hide somebody else's. */
      var sec = g.closest ? g.closest("section") : null;
      if (sec && sec.parentNode === scope) sec.hidden = !any;
    });
    $$("[data-count]").forEach(function (c) { c.textContent = shown; });
    $$("[data-count-s]").forEach(function (c) { c.textContent = shown === 1 ? "" : "s"; });
    $$("[data-filter-clear]").forEach(function (c) {
      c.hidden = !state.collection && !state.colour;
    });
    var empty = $("[data-filter-empty]");
    if (empty) empty.hidden = shown !== 0;
  }

  function clear() {
    state.collection = state.colour = null;
    $$("[data-filter]").forEach(function (b) { b.setAttribute("aria-pressed", "false"); });
    apply();
  }

  if (bar) {
    $$("[data-filter]", bar).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var k = btn.dataset.filter, v = btn.dataset.value;
        state[k] = state[k] === v ? null : v;      /* click again to unset */
        $$('[data-filter="' + k + '"]', bar).forEach(function (b) {
          b.setAttribute("aria-pressed", String(b.dataset.value === state[k]));
        });
        apply();
      });
    });
  }
  $$("[data-filter-clear]").forEach(function (c) {
    c.addEventListener("click", clear);
  });

  /* THE SORT COULD NEVER CROSS A RANGE, AND "NEWEST" DID NOTHING AT ALL
     *(the principal, 2026-09-15: "the filter on the category page doesnt
     work")*. The catalogue is one `.grid` per range -- that is what prints the
     range headings -- and this sorted the cells INSIDE each grid, so Title A-Z
     returned Botanics A-Z, then Ceramics A-Z, then Forestry A-Z. Three sorted
     lists, never a sorted catalogue. Read off the live shop before the fix.

     "Newest" was `return 0`, commented "Newest is catalogue order". The
     catalogue order is grouped by range (`shopify.py order --build`), so the
     default option named a sort the page has never performed while showing the
     one view it does not name: CATEGORIES, which is now the first option and
     the default.

     THE MODE IS AN OPTION VALUE, NEVER A LABEL. The options carried no
     `value`, so `select.value` was the rendered English string and this
     matched `mode.indexOf("Title") === 0` -- a sort that breaks the day the
     shop is translated, on a shop that ships worldwide.

     PRICE IS GONE AND WAS A NO-OP BY CONSTRUCTION: `posters.retail_for()`
     prices a size, not a print, so every cell on the live page carried the
     same `data-price`. */
  var sort = $("#sort");

  /* The served order, captured per cell the first time it is seen. That is
     what lets Categories restore it exactly, and what lets the chunks fetched
     below join the arrangement instead of sitting outside it. */
  var served = [];
  function census() {
    $$(".item", scope).forEach(function (el) {
      if (el.hasAttribute("data-served")) return;
      var g = el.parentNode;
      if (!g || !g.classList || !g.classList.contains("grid")) return;
      el.setAttribute("data-served", "");
      served.push({ el: el, grid: g });
    });
  }

  /* THE FLAT GRID CARRIES NO HEADING AND CANNOT BE GIVEN ONE. That is how
     "without category brackets" is true by construction rather than by a
     caller remembering to hide something. The range grids it empties are
     hidden by apply() above, headings and all, which is the same mechanism the
     colour chips already use -- so heading visibility has exactly one owner. */
  function flat() {
    var sec = $("[data-flat]", scope);
    if (!sec) {
      sec = document.createElement("section");
      sec.className = "wrap band-s";
      sec.setAttribute("data-flat", "");
      var g = document.createElement("div");
      g.className = "grid";
      sec.appendChild(g);
      scope.appendChild(sec);
    }
    return sec.querySelector(".grid");
  }

  /* Nothing is typed: `data-published` is the shop's own publication
     timestamp, rendered so that it sorts as a string. Newest is descending. */
  var ORDER = {
    newest: function (a, b) {
      return (b.dataset.published || "").localeCompare(a.dataset.published || "");
    },
    title: function (a, b) {
      return (a.dataset.title || "").localeCompare(b.dataset.title || "");
    }
  };

  function arrange(mode) {
    census();
    /* Own property only. `mode` comes from the select, so nothing can reach
       an inherited one today -- but `ORDER["constructor"]` is a function and
       would be used as a comparator, which is a class of bug rather than a
       case. */
    var cmp = Object.prototype.hasOwnProperty.call(ORDER, mode)
      ? ORDER[mode] : null;
    if (cmp) {
      var g = flat();
      served.slice().sort(function (x, y) { return cmp(x.el, y.el); })
        .forEach(function (h) { g.appendChild(h.el); });
    } else {
      /* Categories. `served` is in the order the page was served, so putting
         each cell back into its own grid in that order rebuilds it exactly. */
      served.forEach(function (h) { h.grid.appendChild(h.el); });
    }
    apply();     /* the count, the emptied grids and their headings follow */
  }

  /* Bound only where there is a real scope to rearrange. Without one `flat()`
     would append its section to the document, and a collection page with no
     [data-filter-scope] is not a page either builder emits. */
  if (sort && scope !== document)
    sort.addEventListener("change", function () { arrange(sort.value); });
})();

/* THE CATALOGUE IS ONE PAGE, AND SHOPIFY'S `paginate` STOPS AT FIFTY.
   (The principal, 2026-09-15: "The catalogue musnt be paginated, i need
   everything listed on one page.")

   The prototype has always been one page -- it is a static build of the whole
   catalogue -- and the port to Liquid introduced the split, because a Liquid
   `for` over a collection serves at most fifty products and `paginate ... by N`
   refuses an N above that. Read off the live shop the day this was written:
   36 prints, 24 on page one, and the Forestry heading printed TWICE, once on
   each page, which is the one thing the grouping exists to prevent.

   So the chunk is the platform's maximum and this fetches whatever is left,
   appending it into the catalogue's own [data-filter-scope] so the filter, the
   sort and the count keep reaching every cell. The <nav class="pager"> stays in
   the served markup: it is the route through with no JavaScript, and it is
   hidden only once every print is actually on the page.

   A RANGE THAT STRADDLES A CHUNK BOUNDARY IS MERGED, NOT HEADED TWICE. The
   catalogue is ordered grouped-by-range (`shopify.py order --build`), so at
   most one range can straddle, and it is always the last section here and the
   first one there. Appending the section whole would reprint its heading --
   the live defect above, moved rather than fixed.

   Inert in the prototype: nothing there renders [data-catalogue-more]. */
(function () {
  "use strict";

  var host = document.querySelector("[data-catalogue-more]");
  if (!host || !window.fetch || !window.DOMParser) return;
  var scope = document.querySelector("[data-filter-scope]");
  if (!scope) return;

  /* The heading a range section carries, or "" for the unranged one. Read off
     the markup `catalogue-body.liquid` emits; a test binds the two. */
  function headingOf(sec) {
    var h = sec && sec.querySelector(".plate-full__meta p");
    return h ? h.textContent.trim() : "";
  }

  /* THE SORT'S FLAT GRID IS NOT A RANGE SECTION, and it is the last child of
     the scope the moment anyone has sorted. Merging an arriving section into
     it -- both read "" for a heading -- would put a chunk of prints into the
     sorted list unsorted and lose their home grid, so Categories could never
     put them back. It is skipped on both sides: it is not the `last` a heading
     is compared against, and new sections are inserted before it. */
  function flatSection() { return scope.querySelector("[data-flat]"); }

  function absorb(doc) {
    var from = doc.querySelector("[data-filter-scope]");
    if (!from) return "";
    Array.prototype.slice.call(from.children).forEach(function (sec) {
      var last = scope.lastElementChild;
      if (last && last.hasAttribute("data-flat")) last = last.previousElementSibling;
      var grid = last && last.querySelector(".grid");
      if (grid && headingOf(sec) === headingOf(last)) {
        Array.prototype.slice.call(sec.querySelectorAll(".grid > *"))
          .forEach(function (cell) { grid.appendChild(cell); });
      } else {
        scope.insertBefore(sec, flatSection());   /* null behaves as append */
      }
    });
    /* The prints that have just arrived are in range order at the end of the
       page, whatever the reader last chose. Re-firing the control is what
       makes them join it -- and it also re-runs the colour filter over them,
       which nothing did before. */
    var sel = document.querySelector("#sort");
    if (sel) sel.dispatchEvent(new Event("change"));
    var more = doc.querySelector("[data-catalogue-more]");
    return more ? (more.getAttribute("data-catalogue-next") || "") : "";
  }

  /* `left` is a stop, not a budget: a page that pointed at itself would
     otherwise fetch for ever. Fifty a chunk, so this reaches a catalogue of
     two thousand prints and gives up rather than spinning. */
  function pull(url, left) {
    if (!url || left <= 0) return;
    window.fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var next = absorb(new DOMParser().parseFromString(html, "text/html"));
        if (next) pull(next, left - 1);
        else host.hidden = true;   /* every print is here; the pager is now a lie */
      })
      .catch(function () { /* leave the pager alone -- it is the way through */ });
  }

  pull(host.getAttribute("data-catalogue-next"), 40);
})();
